/**
 * Hamburger Menu and Sidebar Logic
 * This module handles the opening/closing of the sidebar navigation
 */

const screenWidth = window.matchMedia("(max-width:768px)");
const sel = (el) => document.querySelector(`${el}`);
const selAll = (el) => document.querySelectorAll(`${el}`);

window.addEventListener("load", function() {
    setTimeout(function() {
        const body = document.body;
        const html = document.documentElement;
        let sidebarOpen = false;

        const sidebar = document.querySelector(".sidebar");
        const sidebarBg = document.querySelector(".sidebar-bg");
        const hambMenus = selAll(".hamb-menu");
        const progressBars = selAll(".progress-bar__progress");
        const desktopHeader = document.querySelector(".desktop-header");
        const logo = sel(".desktop-header .logo");

        // Close sidebar function
        const closeSidebar = function(hambMenu) {
            hambMenu.classList.remove("animate-hamb");
            hambMenu.classList.add("animate-hamb-reverse");
            sidebar.classList.remove("active");
            sidebarBg.classList.remove("active");

            if (logo) {
                logo.classList.remove("blured-logo");
            }

            hambMenus.forEach(function(menu) {
                menu.style.pointerEvents = "none";
            });

            hambMenu.classList.remove("active");

            progressBars.forEach(function(bar) {
                bar.classList.remove("active");
            });

            body.classList.remove("overflow-toggle");
            html.classList.remove("overflow-toggle");

            setTimeout(function() {
                desktopHeader.classList.remove("sidebar-open");
                hambMenus.forEach(function(menu) {
                    menu.style.pointerEvents = "all";
                });
            }, 400);
        };

        // Add click handler to each hamburger menu
        hambMenus.forEach(function(hambMenu, index) {
            hambMenu.addEventListener("click", function() {
                hambMenu.classList.toggle("active");
                progressBars[index].classList.toggle("active");
                sidebarOpen = !sidebarOpen;

                hambMenus.forEach(function(menu) {
                    menu.style.pointerEvents = "none";
                });

                setTimeout(function() {
                    hambMenus.forEach(function(menu) {
                        menu.style.pointerEvents = "all";
                    });
                }, 600);

                if (sidebarOpen) {
                    hambMenu.classList.remove("animate-hamb-reverse");
                    hambMenu.classList.add("animate-hamb");
                    hambMenu.classList.add("active");
                    sidebar.classList.add("active");
                    sidebarBg.classList.add("active");
                    desktopHeader.classList.add("sidebar-open");

                    if (logo) {
                        logo.classList.add("blured-logo");
                    }

                    body.classList.add("overflow-toggle");
                    html.classList.add("overflow-toggle");
                } else {
                    closeSidebar(hambMenu);
                }
            });
        });

        // Close sidebar when clicking on background overlay
        if (sidebarBg) {
            sidebarBg.addEventListener("click", function() {
                hambMenus.forEach(function(hambMenu) {
                    closeSidebar(hambMenu);
                    desktopHeader.classList.remove("sidebar-open");
                });
            });
        }

        // Close sidebar on Escape key press
        window.addEventListener("keydown", function(e) {
            if (e.key === "Escape") {
                hambMenus.forEach(function(hambMenu) {
                    closeSidebar(hambMenu);
                    desktopHeader.classList.remove("sidebar-open");
                });
            }
        });

    }); // end setTimeout
});
